// enci.bootstrap-helper.js

import $ from 'jquery';
import * as bootstrap from 'bootstrap';
// import Draggable from 'draggable';
import Draggabilly from 'draggabilly';
// import $ from 'jquery';
// import { debugLog } from './enci.log.js';

/**
 * @typedef {Object.<number, string>} PageNameMap
 */

/** @type {PageNameMap} */
const PAGE_NAMES = Object.freeze({
  1: 'EfficientMarkets',
  2: 'EnergyNet',
  3: 'Government',
  4: 'Indigo',
  5: 'Renova',
  6: 'Vero',
  7: 'Afe',
  8: 'Minerals',
  9: 'Timber',
  10: 'Alaska',
});

/**
 * Sets the active tab by page ID.
 * @param {number} pageId - The ID of the page to activate.
 */
export function setActiveTabById(pageId) {
  const pageName = PAGE_NAMES[pageId];

  if (!pageName) {
    console.error(`Page ID ${pageId} not found in PAGE_NAMES map.`);
    return;
  }

  const tabIndex = pageId - 1;
  const tabElement = document.querySelector(`#tab${tabIndex}`);
  const tabPaneElement = document.querySelector(`#tab${tabIndex}-pane`);

  if (!tabElement || !tabPaneElement) {
    console.error(`Tab elements for page ID ${pageId} not found.`);
    return;
  }

  activateTab(tabElement);
  updateTabVisibility(tabElement, tabPaneElement);
}

/**
 * Activates a tab using Bootstrap's tab 'show' method.
 * @param {HTMLElement} tabElement - The tab element to activate.
 */
function activateTab(tabElement) {
  new bootstrap.Tab(tabElement).show();
}

/**
 * Updates the visibility of tabs and panes.
 * @param {HTMLElement} activeTabElement - The tab element to make active.
 * @param {HTMLElement} activeTabPaneElement - The tab pane element to make active.
 */
function updateTabVisibility(activeTabElement, activeTabPaneElement) {
  document.querySelectorAll('.nav-link').forEach(el => el.classList.remove('active'));
  document.querySelectorAll('.tab-pane').forEach(el => el.classList.remove('show', 'active'));

  activeTabElement.classList.add('active');
  activeTabPaneElement.classList.add('show', 'active');
}

/**
 * Displays a modal with the specified title and body content.
 * @param {string} modalId - The ID of the modal to display.
 * @param {string} modalTitle - The title to display in the modal.
 * @param {string} modalBody - The body content to display in the modal.
 */
function showModal(modalId, modalTitle, modalBody) {
  const modalElement = document.getElementById(modalId);
  if (!modalElement) {
    console.error(`Modal with ID '${modalId}' not found.`);
    return;
  }

  updateModalContent(modalElement, modalTitle, modalBody);
  bootstrap.Modal.getOrCreateInstance(modalElement).show();
}

/**
 * Updates the content of a modal.
 * @param {HTMLElement} modalElement - The modal element to update.
 * @param {string} title - The title to set.
 * @param {string} body - The body content to set.
 */
function updateModalContent(modalElement, title, body) {
  const titleElement = modalElement.querySelector('.modal-title');
  const bodyElement = modalElement.querySelector('.modal-body');

  if (titleElement && bodyElement) {
    titleElement.textContent = title;
    bodyElement.innerHTML = body;
  }
}

/**
 * Displays a success modal with the specified title and body content.
 * @param {string} modalTitle - The title to display in the success modal.
 * @param {string} modalBody - The body content to display in the success modal.
 */
export function showSuccessModal(modalTitle, modalBody) {
  showModal('successModal', modalTitle, modalBody);
}

/**
 * Displays a failure modal with the specified title and body content.
 * @param {string} modalTitle - The title to display in the failure modal.
 * @param {string} modalBody - The body content to display in the failure modal.
 */
export function showFailureModal(modalTitle, modalBody) {
  showModal('failureModal', modalTitle, modalBody);
}

export function showGenericModal(modalId, modalTitle) { // , modalBody
  // showModal(modalId, modalTitle, modalBody);
    const modalElement = document.getElementById(modalId);
    if (!modalElement) {
      console.error(`Modal with ID '${modalId}' not found.`);
      return;
    }

    const titleElement = modalElement.querySelector('.modal-title');
    // const bodyElement = modalElement.querySelector('.modal-body');

    if (titleElement) { //  && bodyElement
      titleElement.textContent = modalTitle;
      // bodyElement.innerHTML = body;
    }

    bootstrap.Modal.getOrCreateInstance(modalElement).show();
}

/**
 * Initializes Bootstrap tooltips for elements with the attribute data-bs-toggle="tooltip".
 */
export function initializeTooltips() {
  const tooltipTriggerList = Array.from(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
  tooltipTriggerList.forEach(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));
}

/**
 * Configures event listeners for the Bootstrap navbar collapse functionality.
 * @param {string} selector - The CSS selector for the navbar to be observed.
 */
export function initializeNavbarCollapse(selector) {
  const navbar = document.querySelector(selector);
  const header = document.querySelector('header');

  if (!navbar) {
    console.error(`initializeNavbarCollapse >> Element with selector '${selector}' not found.`);
    return;
  }

  navbar.addEventListener('show.bs.collapse', () => header.classList.add('expanded'));
  navbar.addEventListener('hide.bs.collapse', () => header.classList.remove('expanded'));
}

export function makeDraggable(id) {
  const element = document.getElementById(id);
  // const options = {
  //   grid: 10,
  //   onDrag: function () {
  //     debugLog('onDrag');
  //   },
  // };
  // new Draggable(element, options);
  const draggie = new Draggabilly(element, {
    // options...
    handle: '.modal-header',
  });

  return draggie;
}

export function initializeImageModal() {
  window.openImageModal = function (wrapper) {
    var modal = $('#imageModal');
    var modalDialog = modal.find('.modal-dialog');
    var modalImg = $('#modalImage');
    var fullSizeUrl = wrapper.getAttribute('data-full-image');

    modalImg.attr('src', fullSizeUrl);
    modal.modal('show');

    modalImg.on('load', function () {
      var imgWidth = this.naturalWidth;
      var imgHeight = this.naturalHeight;
      var windowWidth = $(window).width() * 0.95; // 95% of window width
      var windowHeight = $(window).height() * 0.95; // 95% of window height

      if (imgWidth > windowWidth || imgHeight > windowHeight) {
        var ratio = Math.min(windowWidth / imgWidth, windowHeight / imgHeight);
        imgWidth *= ratio;
        imgHeight *= ratio;
      }

      modalDialog.css({
        width: imgWidth + 'px',
        'max-width': imgWidth + 'px',
      });
    });
  };

  $('#imageModal').on('hidden.bs.modal', function () {
    $('#modalImage').attr('src', '');
  });
}

$(window).on('resize', function () {
  if ($('#imageModal').hasClass('show')) {
    // Implement this logic to resize the modal dialog
    // openImageModal($('[data-full-image]').first()[0]);
  }
});